import { useEffect } from 'react';
import VanillaTilt from 'vanilla-tilt';
import styles from './Freelance.module.css';

function Freelance() {
    const preventDefault = (event) => {
        event.preventDefault();
    };

  useEffect(() => {
    const tiltElements = document.querySelectorAll(".imd-3d");
    tiltElements.forEach(element => {
      VanillaTilt.init(element, {
        max: 25,
        speed: 400,
        glare: true,
        "max-glare": 0.5,
      });
    });
  }, []);

  return (
    <div>
      <h1 className="text-shadow-active">Freelance Work</h1>
      <div>
      <span>↓ Resume: </span>
          <a href="/assets/resume/RESUME-F.pdf" download="Volt's Resume (PDF).pdf" className={ styles.freelanceATagSummary }> PDF</a>
          <span> | </span>
          <a href="/assets/resume/RESUME-F.docx" download="Volt's Resume (DOCX).docx" className={ styles.freelanceATagSummary }>  DOCX  </a>
      </div>

      <div className="popup-divider"></div>

      <h2  className='mb-3 mt-3 text-shadow-active'>Mobile</h2>
      {/* SNOOZLY section*/}
      <div className={ styles.freelanceSection}>
        <div className={ styles.mobileImgSection }>
            <div className="imd-3d">
                <img className={ styles.imgMobile + " me-2" } src="/assets/images/snoozly-ios/screen1.png" alt="snoozly1" />
                <img className={ styles.imgMobile } src="/assets/images/snoozly-ios/screen2.png" alt="snoozly2" />
            </div>
        </div>
        <div className={ styles.freelanceDescSection }>
          <h3>SNOOZLY(iOS)</h3>
          <span>Story generation and telling for kids</span>
          <p>
            <span>STATUS:</span> 
            <a className="live" href="https://apps.apple.com/gh/app/snoozly-bedtime-story-for-kids/id6464295839" target="_blank" rel="noreferrer">
                <strong> APPSTORE</strong>
            </a>
            <i> ← click to view</i>
          </p>

          <p>Stack:
              <ul>
                <li>Frontend: iOS(Swift), Storyboard</li>
                <li>Database: Firebase</li>
              </ul>
          </p>
        </div>
      </div>

      {/* EROVIA section*/}
      <div className={ styles.freelanceSection}>
        <div className={ styles.mobileImgSection }>
            <div className="imd-3d">
                <img className={ styles.imgMobile + " me-2" } src="/assets/images/erovia-ios/screen1.png" alt="erovia1" />
                <img className={ styles.imgMobile } src="/assets/images/erovia-ios/screen2.png" alt="erovia2" />
            </div>
        </div>
        <div className={ styles.freelanceDescSection }>
          <h3>EROVIA(iOS)</h3>
          <span>R-Rated story app generation for adult</span>
          <p>
            <span>STATUS:</span> 
            <a className="not-live" href="/" onClick={preventDefault}>
              <strong> OFFLINE</strong>
            </a>
          </p>

          <p>Stack:
              <ul>
                <li>Frontend: iOS(Swift), Storyboard</li>
                <li>Database: Firebase</li>
              </ul>
          </p>
        </div>
      </div>

      {/* AHHA section*/}
      <div className={ styles.freelanceSection}>
        <div className={ styles.mobileImgSection }>
            <div className="imd-3d">
                <img className={ styles.imgMobile + " me-2" } src="/assets/images/ahha-ios/screen1.webp" alt="ahha1" />
                <img className={ styles.imgMobile } src="/assets/images/ahha-ios/screen2.png" alt="ahha2" />
            </div>
        </div>
        <div className={ styles.freelanceDescSection }>
          <h3>AHHA(iOS)</h3>
          <span>Organization app for Australian Org</span>
          <p>
            <span>STATUS:</span> 
            <a className="live" href="https://apps.apple.com/au/app/ahha-au/id6443931328" target="_blank" rel="noreferrer">
                <strong> APPSTORE</strong>
            </a>
            <i> ← click to view</i>
          </p>

          <p>Stack:
              <ul>
                <li>Frontend: iOS(Swift), UIKit</li>
                <li>Backend: PHP</li>
                <li>Database: Firebase</li>
              </ul>
          </p>
        </div>
      </div>

      {/* AXREM section*/}
      <div className={ styles.freelanceSection}>
        <div className={ styles.mobileImgSection }>
            <div className="imd-3d">
                <img className={ styles.imgMobile + " me-2" } src="/assets/images/axrem-ios/screen1.png" alt="axrem1"/>
                <img className={ styles.imgMobile } src="/assets/images/axrem-ios/screen2.png" alt="axrem1"/>
            </div>
        </div>
        <div className={ styles.freelanceDescSection }>
          <h3>AXREM(iOS)</h3>
          <span>Organization app for Australian Org</span>
          <p>
            <span>STATUS:</span> 
            <a className="not-live" href="/" onClick={preventDefault}>
              <strong> OFFLINE</strong>
            </a>
          </p>

          <p>Stack:
              <ul>
                <li>Frontend: iOS(Swift), UIKit</li>
                <li>Backend: PHP</li>
                <li>Database: Firebase</li>
              </ul>
          </p>
        </div>
      </div>

      <div className="popup-divider"></div>

      <h2 className='mb-5 text-shadow-active'>Web</h2>
      {/* THINKTHIRSTY section*/}
      <div className={ styles.freelanceSection}>
        <div className={ styles.webImgSection }>
          <img className="imd-3d" src="/assets/images/thinkthirsty-web/tty-main.png" alt="tty1"/>
        </div>
        <div className={ styles.freelanceDescSection }>
          <h3>Thinkthirsty</h3>
          <span>Promotional company website</span>
          <p>
            <span>STATUS:</span> 
            <a className="not-live" href="/" onClick={preventDefault}>
              <strong> OFFLINE</strong>
            </a>
          </p>
          <p>Stack:
              <ul>
                <li>Frontend: Vue.js, Bootstrap, Three.js</li>
                <li>Hosting: GoDaddy</li>
              </ul>
          </p>
        </div>
      </div>

      {/* FITTODACHI section*/}
      <div className={ styles.freelanceSection}>
        <div className={ styles.webImgSection }>
          <img className="imd-3d" src="/assets/images/fittodatchi-web/fdi-main.png" alt="fdi1"/>
        </div>
        <div className={ styles.freelanceDescSection }>
          <h3>Fittodachi</h3>
          <span>Promotional gaming website</span>
          <p>
            <span>STATUS:</span> 
            <a className="not-live" href="/" onClick={preventDefault}>
              <strong> OFFLINE</strong>
            </a>
          </p>

          <p>Stack:
              <ul>
                <li>Frontend: Vue.js, Bootstrap, Three.js</li>
                <li>Backend: Laravel</li>
                <li>Database: MySQL</li>
                <li>Hosting: GoDaddy</li>
              </ul>
          </p>
        </div>
      </div>

      {/* SHADOWBOT section*/}
      <div className={ styles.freelanceSection}>
        <div className={ styles.webImgSection }>
          <img className="imd-3d" src="/assets/images/shadowbot-web/screen1.png" alt="sdb1"/>
        </div>
        <div className={ styles.freelanceDescSection }>
          <h3>ShadowBot</h3>
          <span>Online platform for user to check their bitcoins</span>
          <p>
            <span>STATUS:</span> 
            <a className="not-live" href="/" onClick={preventDefault}>
              <strong> OFFLINE</strong>
            </a>
          </p>

          <p>Stack:
              <ul>
                <li>Frontend: Vue.js, Bootstrap</li>
                <li>Backend: Laravel, Stripe(Ongoing)</li>
              </ul>
          </p>
        </div>
      </div>

      {/* IMpatient section*/}
      <div className={ styles.freelanceSection}>
        <div className={ styles.webImgSection }>
          <img className="imd-3d" src="/assets/images/impatient-web/ipt-main.png" alt="ipt1"/>
        </div>
        <div className={ styles.freelanceDescSection }>
          <h3>IMPatient</h3>
          <span>Teleconsultation platform for doctor and patient.</span>
          <p>
            <span>STATUS:</span> 
            <a className="not-live" href="/" onClick={preventDefault}>
              <strong> OFFLINE</strong>
            </a>
          </p>

          <p>Stack:
              <ul>
                <li>Frontend: Vue.js, Bootstrap</li>
                <li>Backend: Laravel</li>
                <li>Database: MySQL</li>
              </ul>
          </p>
        </div>
      </div>

      <div className="popup-divider"></div>

      <div className={ styles.freelanceResumeContainer }>
          <a href="./assets/resume/RESUME-F.docx" download="Volt's Resume (docx).docx" className={ styles.freelanceATag }>
              <div className="my-3 mx-auto">
                  <img src="/assets/images/aboutus/save-file.png" alt="Temp 4" className={ styles.freelanceIcon }/>
                  <span className={ styles.freelanceLabel + " mx-3"} >Resume - Freelance (.docx)</span>
              </div>
          </a>
          
          <a href="./assets/resume/RESUME-F.pdf" download="Volt's Resume (PDF).pdf" className={ styles.freelanceATag }>
              <div className="my-3 mx-auto">
                  <img src="/assets/images/aboutus/save-file.png" alt="Temp 4" className={ styles.freelanceIcon }/>
                  <span className={ styles.freelanceLabel + " mx-3"} >Resume - Freelance (PDF)</span>
              </div>
          </a>
      </div>

    </div>
  );
}

export default Freelance;